import { BaseDto } from './base.dto';
import { SitemapCreateDto } from './sitemap';
import { UserRoleDto } from './userRole.dto';

export class RoleComponentDto extends BaseDto {
  roleId?: number;
  role?: UserRoleDto;
  roleDescription: string;
  sitemaps?: SitemapCreateDto[];
  purchasingCanSeePrices: boolean;
  canTopUp: boolean;
  canRedeem: boolean;
  merchantGroupId?: number;
  isSuperAuthoriser: boolean;
  allowDirectGoodsReceived: boolean;
  timeoutAfterMinutes: number;
  isActive: boolean;
  chatRole: string;
  allowChatDirectMessages: boolean;
  allowChatWithDifferentJobTitle: boolean;
  allowChatWithDifferentMerchant: boolean;
  allowChatWithDifferentCostCentre: boolean;
}
